export type Lang = "en" | "jp";

export type TranslationKey =
  | "nav_home" | "nav_projects" | "nav_products" | "nav_about"
  | "hero_subtitle" | "hero_desc" | "hero_cta"
  | "projects_title" | "projects_subtitle"
  | "projects_filter_label" | "projects_filter_all" | "projects_filter_web" | "projects_filter_desktop"
  | "projects_filter_bot" | "projects_filter_tool" | "projects_filter_fun" | "projects_filter_app"
  | "projects_empty"
  | "products_title" | "products_subtitle" | "products_empty"
  | "about_title" | "about_p1"
  | "footer_made" | "footer_legal"
  | "card_view" | "card_private"
  | "select_lang" | "select_theme"
  | "language_english" | "language_japanese"
  | "theme_white" | "theme_cream" | "theme_dark" | "theme_black";

export const TRANSLATIONS: Record<Lang, Record<TranslationKey, string>> = {
  en: {
    nav_home: "home", nav_projects: "projects", nav_products: "products", nav_about: "about",
    hero_subtitle: "experiments & projects",
    hero_desc: "a personal lab for things that may or may not work",
    hero_cta: "explore",
    projects_title: "projects",
    projects_subtitle: "experiments, experiments, experiments.",
    projects_filter_label: "filter projects",
    projects_filter_all: "all", projects_filter_web: "web", projects_filter_desktop: "desktop",
    projects_filter_bot: "bot", projects_filter_tool: "tool", projects_filter_fun: "fun", projects_filter_app: "app",
    projects_empty: "no projects yet — check back later",
    products_title: "products",
    products_subtitle: "finished things. or close enough.",
    products_empty: "no products yet",
    about_title: "about",
    about_p1: "the lab is a dedicated space for experiments, side projects, and things that exist purely because they seemed interesting at the time.",
    footer_made: "made by", footer_legal: "legal",
    card_view: "view →", card_private: "private",
    select_lang: "LANG", select_theme: "Theme",
    language_english: "English", language_japanese: "Japanese",
    theme_white: "White", theme_cream: "Cream", theme_dark: "Dark", theme_black: "Black",
  },
  jp: {
    nav_home: "ホーム", nav_projects: "プロジェクト", nav_products: "プロダクト", nav_about: "について",
    hero_subtitle: "実験とプロジェクト",
    hero_desc: "動くかもしれないし、動かないかもしれないものを作る個人ラボ",
    hero_cta: "探索する",
    projects_title: "プロジェクト",
    projects_subtitle: "実験、実験、実験。",
    projects_filter_label: "プロジェクトを絞り込む",
    projects_filter_all: "すべて", projects_filter_web: "ウェブ", projects_filter_desktop: "デスクトップ",
    projects_filter_bot: "ボット", projects_filter_tool: "ツール", projects_filter_fun: "遊び", projects_filter_app: "アプリ",
    projects_empty: "まだプロジェクトはありません",
    products_title: "プロダクト",
    products_subtitle: "完成したもの、またはそれに近いもの。",
    products_empty: "まだプロダクトはありません",
    about_title: "について",
    about_p1: "実験、サイドプロジェクト、面白そうだからという理由だけで存在するものための場所です。",
    footer_made: "制作者", footer_legal: "法的情報",
    card_view: "見る →", card_private: "非公開",
    select_lang: "言語", select_theme: "テーマ",
    language_english: "英語", language_japanese: "日本語",
    theme_white: "ホワイト", theme_cream: "クリーム", theme_dark: "ダーク", theme_black: "ブラック",
  },
};

export const t = (lang: Lang, key: TranslationKey): string =>
  TRANSLATIONS[lang][key] ?? TRANSLATIONS.en[key];
